import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Spinner } from "@/components/ui/spinner";

/**
 * Loading Component
 *
 * Reusable loading screen component using ShadCN components.
 * Displays a centered card with skeleton loaders and a spinner.
 */
export function Loading() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <Skeleton className="h-8 w-32 mx-auto mb-2" />
          <Skeleton className="h-4 w-48 mx-auto" />
        </CardHeader>
        <CardContent>
          <div className="flex justify-center">
            <Spinner className="size-8" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
